import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

function showBootstrapError(error: unknown): void {
  const container = document.getElementById('bootstrap-error');
  if (!container) {
    return;
  }

  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : 'The application failed to start.';

  container.hidden = false;
  container.innerHTML = `
    <div style="
      box-sizing: border-box;
      min-height: 100vh;
      padding: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      background: #fafafa;
      color: #1a1a1a;
    ">
      <div style="
        max-width: 420px;
        width: 100%;
        background: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 12px;
        padding: 24px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
      ">
        <h1 style="margin: 0 0 12px; font-size: 20px;">Unable to load Logibids Admin</h1>
        <p style="margin: 0 0 16px; line-height: 1.5; color: #555;">
          ${message}
        </p>
        <button
          type="button"
          onclick="window.location.reload()"
          style="
            width: 100%;
            border: 0;
            border-radius: 8px;
            padding: 12px 16px;
            background: #8B0000;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
          ">
          Reload
        </button>
      </div>
    </div>
  `;
}

if ('serviceWorker' in navigator && window.location.hostname === 'localhost') {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      const scriptUrl = registration.active?.scriptURL ?? '';

      // Keep Firebase SW for local push-notification testing.
      if (scriptUrl.includes('firebase-sw.js')) {
        continue;
      }

      registration.unregister();
      console.log(
        'Unregistered service worker on localhost:',
        scriptUrl || registration.scope
      );
    }
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => {
  console.error(err);
  showBootstrapError(err);
});

window.addEventListener('unhandledrejection', event => {
  const reason = event.reason;
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : '';

  if (
    message.includes('Google Maps') ||
    message.includes('APP_INITIALIZER') ||
    message.includes('NG0')
  ) {
    console.error('Unhandled bootstrap rejection:', reason);
    showBootstrapError(reason);
  }
});
